import {base, baseConfig} from '../Services/api';

export const getPerformance = (period, siteId) => fetch(
  `${base}performance?${new URLSearchParams({...(typeof period === 'string' ? {startDate: period} : period), ...(siteId ? {siteId} : {})})}`, baseConfig
);
